import React from 'react';

export const NumberFilter: React.ComponentType<{
  onChange: (values: string[]) => void;
  value?: string[];
}> = ({onChange, value = []}) => {
  return (
    <></>
  );
};
